/**
 * window.Drupal.t polyfill
 * @param str
 */
if (!window.Drupal) {
  window.Drupal = {
    t: (str) => str,
  };
}

const EtrTranslate = {
  pageRubrique: {
    button_pagination_show_more: window.Drupal.t('etr: Afficher plus'),
    button_header_chapo_show_more: window.Drupal.t('etr: Afficher plus'),
    placeholder_header_search: window.Drupal.t('etr: Rechercher dans cette rubrique...'),
    result_message: window.Drupal.t('etr: Tous les résultats pour'),
    result_message_lien_retour: window.Drupal.t('etr: Retour à “tous les contenus”'),
    no_result_message_title: window.Drupal.t('etr: Nous n’avons pas de résultat à vous proposer pour'),
    no_result_message_text: window.Drupal.t('etr: Tout comme l\'ensemble des recherches infructueuses, les termes de votre recherche vont être analysés dans l’objectif pour Santé.fr de pouvoir répondre à l’ensemble des questions posées.'),
    no_result_message_title_suggestion: window.Drupal.t('etr: Tous les contenus pour'),
    button_floating_bar: window.Drupal.t('etr: explorez le periple autrement'),
    zone_cards_colomne_title: window.Drupal.t('etr: Dans cette rubrique'),
  },
  dynamicView: {
    btnEnterFullscreen: window.Drupal.t('etr: voir en plein écran'),
    btnExitFullscreen: window.Drupal.t('etr: Sortir du mode plein écran'),
  },
  menuEtr: {
    title_menu_bt_plus: window.Drupal.t('Voir la suite du menu'),
    title_menu_bt_left: window.Drupal.t('Faire défiler le menu vers la gauche'),
    title_menu_bt_right: window.Drupal.t('Faire défiler le menu vers la droite'),
    title_sub_menu: window.Drupal.t('etr menu: À la une de'),
  },
};

export default EtrTranslate;
